import globalConstant from 'constants/globalConstant';
import API_CONSTANT from 'constants/apiConstant';
import APP_ROUTES_CONSTANT from 'constants/appRouteConstants';
import GLOBAL_CONSTANT from 'constants/globalConstant';
import { put, takeLeading } from 'redux-saga/effects';
import { triggerHomeDetailsApiCallSuccess } from 'redux/actions';
import { TRIGGER_HOME_DETAILS_API } from 'redux/actionTypes';
import store from 'redux/store';
import { apiCall } from 'services';
import {
	ChangeHistory,
	CleverTapEvent,
	CleverTapEventNames,
	getAppVersion,
	getURLParameter,
	isIOS,
	nativeHandler,
} from 'utils';
import { isSuperAppHome } from 'utils/isSuperAppHome';

function* triggerHomeDetailsApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const STOP_ROUTE = data?.['stopRoute'];
	const VERIFY_PAN = data?.['verifyPan'];
	const FIRE_ACCOUNT_CREATION_EVENT = data?.['fireAccountCreationEvent'];
	const FIRE_ELIGIBILITY_EVENT = data?.['fireEligibilityEvent'];
	const RECEIVED_LIMIT_ACCOUNT_ONBOARDING = data?.['isReceivedLimitAccountOnboarding'];

	const appVersion =
		getAppVersion() ||
		parseInt(getURLParameter(globalConstant.URL_PARAMETER.APPVERSION).toString().split('.').join('')?.trim());
	const isAppVersionEligibleforMigration = () => {
		if (isIOS) return appVersion >= 124;
		return appVersion >= 147;
	};

	const isOnboardingEnabled = store.getState().featureAccess?.onboardingEnabled;

	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.HOME,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
			handleRetry: true,
			dontRemoveLoader: true,
		},
	});

	// console.log(api, 'old api');
	// console.log(api, getURLParameter('home-version'), '------------ old api ----------------');
	// const apiv2 = yield apiCall({
	// 	urlType: API_CONSTANT.URL_TYPE.POST_PE_V2,
	// 	url: 'https://api-postpe-uat2.bharatpe.in/postpe/credit-account/v1',
	// 	method: 'GET',
	// 	options: {
	// 		defaultLoader: !stopLoader,
	// 		handleRetry: true,
	// 		dontRemoveLoader: true,
	// 	},
	// });

	// console.log(apiv2, '------------ New api ----------------');

	const lenderLimitDetails = ['BLOCKED', 'ACTIVE'].includes(api?.data?.data?.accountStatus)
		? yield apiCall({
				urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
				url: API_CONSTANT.URL.LENDER_UPGRADE_DETAILS,
				method: 'GET',
				options: {
					defaultLoader: !stopLoader,
					handleRetry: true,
					dontRemoveLoader: true,
				},
		  })
		: {};

	if (api && api.data.data) {
		let apiData = api.data.data;
		callback && callback(apiData);
		const wrouteValue = getURLParameter(globalConstant.URL_PARAMETER.WROUTE) || ''; //need to remove re-verify

		if (apiData?.eligibleForSuperAppMigration && isAppVersionEligibleforMigration) {
			return ChangeHistory('push', '/super-app-migration-ll');
		}
		if (
			apiData?.accountStatus === 'ACTIVE' &&
			apiData?.postPaidAccount?.lender === GLOBAL_CONSTANT.LENDER.LDC &&
			!['ccTxnStatus', 'creditCard', 'txnStatus'].includes(wrouteValue)
		) {
			yield put(triggerHomeDetailsApiCallSuccess(apiData));
			return ChangeHistory('push', APP_ROUTES_CONSTANT.onboarding.upgrade);
		}

		if (
			!isOnboardingEnabled &&
			['NA', 'INELIGIBLE', 'WAITLIST', 'INIT'].includes(apiData?.accountStatus) &&
			!isSuperAppHome()
		) {
			return ChangeHistory('push', APP_ROUTES_CONSTANT.onboarding.upgrade);
		}

		if (
			!isOnboardingEnabled &&
			!apiData?.postPaidAccount?.agreement &&
			apiData?.accountType === GLOBAL_CONSTANT.ACCOUNT_STATUS.POSTPAID
		) {
			apiData['baseRoute'] = APP_ROUTES_CONSTANT.onboarding.upgrade;
			yield put(triggerHomeDetailsApiCallSuccess(apiData));
			return;
		}

		if (
			apiData?.accountType === 'POSTPAID' &&
			apiData?.postPaidAccount &&
			apiData?.kycLevel !== 2 &&
			!isSuperAppHome()
		) {
			apiData['baseRoute'] = 'kyc';
			yield put(triggerHomeDetailsApiCallSuccess(apiData));
			return;
		}

		if (!STOP_ROUTE && !isSuperAppHome()) {
			switch (apiData?.accountStatus) {
				case 'NA':
					apiData['baseRoute'] = isOnboardingEnabled ? '/onboarding/enter-pan' : APP_ROUTES_CONSTANT.onboarding.upgrade;
					break;
				case 'INIT':
					if (isOnboardingEnabled) {
						if (apiData?.kycLevel === 2) {
							apiData['baseRoute'] = '/onboarding/activation-progress';
						} else if (apiData?.accountType === 'RECEIVED_LIMIT') {
							apiData['baseRoute'] = '/received-limit/home';
						} else {
							FIRE_ACCOUNT_CREATION_EVENT &&
								CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.ACCOUNT_CREATED);

							apiData['baseRoute'] = 'kyc';
						}
						break;
					}

					apiData['baseRoute'] = APP_ROUTES_CONSTANT.onboarding.upgrade;
					break;

				case 'INACTIVE':
					if (apiData?.accountType === 'RECEIVED_LIMIT') {
						apiData['baseRoute'] = '/received-limit/home';
					} else {
						apiData['baseRoute'] = '/onboarding/agreement';
					}
					break;
				case 'CONTACT_REFERENCES_PENDING':
					apiData['baseRoute'] = '/onboarding/add-reference';
					break;
				case 'LENDER_APPROVAL_PENDING':
				case 'AGREEMENT_PENDING':
					//for LENDER_APPROVAL_PENDING case :
					// apiData['baseRoute'] = '/onboarding/annual-income';
					// break;
					// if (apiData?.userDataDto?.emailVerified == false)
					// 	apiData['baseRoute'] = '/onboarding/additional-details-email';
					// else if (apiData?.userDataDto?.isAddressSaved == false)
					// 	apiData['baseRoute'] = '/onboarding/additional-details-address';
					// else apiData['baseRoute'] = '/onboarding/agreement';
					apiData['baseRoute'] = '/onboarding/upgrade'; //redo

					break;
				case 'LENDER_REJECTED':
					apiData['baseRoute'] = '/onboarding/lender-process';
					break;
				case 'CLOSED':
					if (apiData?.postPaidAccount?.lender === 'ARC') {
						apiData['baseRoute'] = '/arcUsers';
						break;
					}
					apiData['baseRoute'] = '/closed';
					break;
				case 'ACTIVE':
				case 'BLOCKED':
				case 'PERMANENT_BLOCKED':
					if (apiData?.accountType === 'POSTPAID' && apiData?.postPaidAccount) {
						apiData['baseRoute'] = apiData['baseRoute'] || APP_ROUTES_CONSTANT.postpaid.home;
						apiData = { ...apiData, ...apiData?.postPaidAccount };
					} else if (apiData?.accountType === 'PREPAID' && apiData?.prePaidAccount) {
						apiData['baseRoute'] =
							apiData?.kycLevel !== 2 ? 'kyc' : apiData?.prePaidAccount ? '/prepaid/home' : '/prepaid/agreement';
						apiData = { ...apiData, ...apiData?.prePaidAccount };
					} else {
						apiData['baseRoute'] = APP_ROUTES_CONSTANT.somethingWrong;
					}
					break;

				/* uncomment this when deposit goes live  */

				// case 'INELIGIBLE':
				// 	nativeHandler.removeLoader();
				// 	if (apiData?.kycLevel !== 2) {
				// 		apiData['baseRoute'] = 'kyc';
				// 	} else {
				// 		if (apiData?.accountType === 'POSTPAID') {
				// 			apiData['baseRoute'] = '/prepaid/agreement';
				// 		} else {
				// 			apiData['baseRoute'] = '/onboarding/waitlist';
				// 		}
				// 	}
				// 	break;

				case 'PREACTIVE':
					apiData['baseRoute'] = RECEIVED_LIMIT_ACCOUNT_ONBOARDING ? 'kyc' : '/received-limit/home';
					break;

				/* remove this INELIGIBLE case when deposit goes live  */
				case 'INELIGIBLE':
				case 'WAITLIST':
					const loanDetails = yield apiCall({
						urlType: API_CONSTANT.URL_TYPE.DSA_LOAN,
						url: API_CONSTANT.URL.DSA_LOAN,
						method: 'POST',

						options: {
							defaultLoader: !stopLoader,
							handleRetry: true,
							dontRemoveLoader: true,
						},
					});
					if (apiData?.accountType === 'RECEIVED_LIMIT') {
						apiData['baseRoute'] = '/received-limit/home';
					} else {
						FIRE_ELIGIBILITY_EVENT && CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.INELIGIBLE);
						apiData['baseRoute'] = isOnboardingEnabled
							? loanDetails?.data && loanDetails?.data?.is_pre_validated === false && apiData?.kycLevel === 2
								? '/onboarding/check-loan-eligibility'
								: '/onboarding/waitlist'
							: APP_ROUTES_CONSTANT.onboarding.upgrade;
					}
					break;

				default:
					break;
			}
			if (lenderLimitDetails && lenderLimitDetails?.data?.lenderUpgrade) {
				apiData['baseRoute'] = '/onboarding/upgrade-screen'; //redo
			}
		} else {
			apiData['baseRoute'] = apiData['baseRoute'] || '';
			nativeHandler.removeLoader();
		}
		if (apiData['baseRoute'] == '' && VERIFY_PAN && apiData?.verifyPan) {
			apiData['baseRoute'] = '/onboarding/verify-pan';
		}
		yield put(triggerHomeDetailsApiCallSuccess(apiData));
	} else {
		nativeHandler.removeLoader();
		if (api.status === 401) {
			localStorage.clear();
			nativeHandler.logout('logout_sagas_general');
		} else {
			ChangeHistory('push', APP_ROUTES_CONSTANT.somethingWrong);
		}
	}
}

export default function* triggerHomeDetailsApiCallSaga() {
	yield takeLeading(TRIGGER_HOME_DETAILS_API, triggerHomeDetailsApiCall);
}
